module.exports = __webpack_public_path__ + "koddi.8b6fb2c7.png";